import styled from "styled-components";
import Fundo from '../img/Gradiente_Transparente.png';

export const DivEtiquetas = styled.div`
    position: relative;
    margin: 2vh auto 0;
    width: 85.9%;
    aspect-ratio: 1920 / 962;
    overflow: hidden;
    border-radius: 6px;
    border: 2px solid #d5d5d5;
    box-sizing: border-box;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    background-image: url(${Fundo});
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;

    .conteudo {
        position: absolute;
        inset: 0;
        display: flex;
        flex-direction: column;
        gap: 1%;
        padding: 1.5% 2%;
        box-sizing: border-box;
    }

    .linha1 {
        flex: 1;
        display: flex;
        align-items: stretch;
        min-height: 0;
        border-radius: 0.6vw;
        overflow: hidden;
        border: 2px solid rgba(213, 213, 213, 0.7);
    }

    .imagens {
        width: 30%;
        background-color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        img.logo {
            width: 70%;
            height: 70%;
            object-fit: contain;
        }
    }

    .titulos {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        background-color: rgba(70, 70, 70, 0.4);
        font-weight: bold;
        font-size: 2.4vw;
        color: white;

        .tecnica {
            margin-top: 0.6vw;
            font-size: 1.5vw;
            color: #87CEFA;

            a {
                text-decoration: none;
                color: #48D1CC;

                :hover {
                    text-decoration: underline;
                }
            }
        }
    }

    @media screen and (max-width: 750px) {
        aspect-ratio: auto;
        width: 100%;
        margin: 0px;
        border-radius: 0px;

        .titulos {
            font-size: 4.2vw;

            .tecnica {
                font-size: 2.6vw;
            }
        }
    }
`;
